"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proSkinBanner = void 0;
var utils_1 = require("../../utils");
var qs = require("qs");
exports.proSkinBanner = function (axios) {
    return {
        /** @deprecated getSkinBannersV2 사용해주세요*/
        getSkinBanners: function (request) {
            return axios.get('/skin-banners', request);
        },
        getSkinBannersV2: function (request) {
            return axios.get('/skin-banners', {
                params: request.params,
                paramsSerializer: function (params) {
                    return qs.stringify(params, { arrayFormat: 'comma' });
                }
            });
        },
        /** @deprecated putSkinBannersV2를 사용해주세요. */
        putSkinBanners: function (request) {
            return axios.put('/skin-banners', request.data);
        },
        /** @deprecated postSkinBannersV2를 사용해주세요. */
        postSkinBanners: function (request) {
            return axios.post('/skin-banners', request.data);
        },
        putSkinBannersV2: function (request) {
            return axios.put('/skin-banners', request.data);
        },
        postSkinBannersV2: function (request) {
            return axios.post('/skin-banners', request.data);
        },
        deleteSkinBanners: function (request) {
            return axios.delete('/skin-banners', request);
        },
        getSkinBannersGroups: function (request) {
            return axios.get('/skin-banners/groups', request);
        },
        getSkinBannersBannerNoPreview: function (request) {
            var url = utils_1.paramPathchange('/skin-banners/{bannerNo}/preview', request);
            return axios.get(url);
        },
        getSkinBannersBannerNo: function (request) {
            var url = utils_1.paramPathchange('/skin-banners/{bannerNo}', request);
            return axios.get(url);
        },
        putSkinBannersDisplayable: function (request) {
            var url = "/skin-banners/" + request.pathParams.bannerNo + "/displayable?displayable=" + request.params.displayable + "&bannerNo=" + request.pathParams.bannerNo;
            return axios.put(url);
        },
        getSkinBannersDuplicate: function (request) {
            return axios.get('/skin-banners/duplicate', request);
        }
    };
};
